import { render } from "./BackButton.vue?vue&type=template&id=5bf4c76f&scoped=true&ts=true"
import script from "./BackButton.vue?vue&type=script&lang=ts"
export * from "./BackButton.vue?vue&type=script&lang=ts"

import "./BackButton.vue?vue&type=style&index=0&id=5bf4c76f&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf4c76f"]])

export default __exports__